import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasEnCargaDescargaZE as Comp } from "./comp";

export interface Props {
    idCargaZE: number;
}

/**Toma el idCargaDescarga y muestra las guias incluidas */
export class GuiasEnCargaZE extends React.PureComponent<Props> {
    idCargaZE = (props: Props) => props.idCargaZE;
    guias = createSelectorRx(this.idCargaZE, idCargaZE => observeResource(resources.CargaZE.ObtenerGuiasEnCargaZE, idCargaZE));

    onQuitarGuia = async (x: models.GuiaDTO) => {
        const idCargaZE = this.props.idCargaZE;
        await resources.CargaZE.QuitarGuia(idCargaZE, x.IdRegistro);
    }

    render() {
        const guias = this.guias(this.props);
        return <Comp value={guias} onQuitarGuia={this.onQuitarGuia} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/status/items/guias/index.tsx